import React from 'react'
import TimeLineSection from '../components/TimelineSection'
import { Helmet } from 'react-helmet'
import { AroraHero } from '../components/AroraHero'
import Navbar from '../components/Navbar'
import Footer from '../components/Footer'

function TimeLine() {
  return (
    <div>
        <Helmet>
            <title>TimeLine | Syed Kaab Surkhi</title>
        </Helmet>
        <AroraHero />
        <div className="overlay-content">
            <Navbar />
            <div className="pt-[10rem]">
                <TimeLineSection />
            </div>
            <Footer />
        </div>
    </div>
  )
}

export default TimeLine